/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button, Input, ModalBody, ModalFooter, ModalHeader, Select, SelectItem } from "@nextui-org/react";
import { useSelector } from 'react-redux';
import toast from "react-hot-toast";
import moment from "moment";
import { formatAmount, formatNumber, formatToApi } from "../../../utils";
import { TeacherTestsService } from "../../../services";


const QuestionEdit = ({ question, onClose, onSuccess }) => {
  const { form, onChange, onSubmit, indicators } = useForm(question);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }

  return (
    <>
      <ModalHeader className="flex items-center gap-1">
        <p>Editar pregunta</p>
      </ModalHeader>
      <ModalBody className="gap-8">
        <Input
          label="Fecha"
          labelPlacement="outside"
          placeholder=" "
          type="date"
          radius="sm"
          variant="bordered"
          value={form.date}
          onValueChange={v => onChange(v, 'date')}
        />
        <Input
          label="Tema generador"
          labelPlacement="outside"
          placeholder=" "
          radius="sm"
          variant="bordered"
          value={form.theme_generator}
          onChange={(e) => onChange(e.target.value, 'theme_generator')}
        />
        <Input
          label="Nombre de la evaluación"
          labelPlacement='outside'
          placeholder=' '
          radius='sm'
          variant='bordered'
          value={form.name}
          onChange={(e) => onChange(e.target.value, 'name')}
        />
        <Select
          label="Tipo de evaluación / Indicadores"
          labelPlacement="outside"
          placeholder=" "
          variant="bordered"
          radius="sm"
          classNames={{ label: 'font-semibold' }}
          disallowEmptySelection={true}
          selectedKeys={(form.indicator_id && indicators.length) ? [form.indicator_id] : []}
          onSelectionChange={v => onChange(v.currentKey, 'indicator_id')}
        >
          {indicators.map((item) => (
            <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
          ))}
        </Select>
        <Input
          label="Porcentaje"
          labelPlacement='outside'
          placeholder=' '
          radius='sm'
          variant='bordered'
          value={form.percentage}
          onChange={(e) => onChange(e.target.value, 'percentage')}
        />
        <Input
          label="Observaciones"
          labelPlacement='outside'
          placeholder=' '
          radius='sm'
          variant='bordered'
          value={form.observations}
          onChange={(e) => onChange(e.target.value, 'observations')}
        />
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button
          className="bg-green"
          color="primary"
          onPress={submit}
        >
          Editar
        </Button>
      </ModalFooter>
    </>
  )
}


const useForm = (question) => {
  const initialForm = {
    id: question?.id,
    date: moment(question?.date).format('YYYY-MM-DD'),
    theme_generator: question?.theme_generator ?? '',
    name: question?.name ?? '',
    indicator_id: question?.indicator_id ? String(question.indicator_id) : '',
    percentage: formatAmount(question?.percentage) ?? '',
    observations: question?.observations ?? '',
  }
  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);
  const [indicators, setIndicators] = useState([]);

  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

  const getSelects = async () => {
    try {
      const resData = await TeacherTestsService.tests.getIndicators({
        professor_id: user.id,
        school_year_id: question?.school_lapse?.school_year_id,
        subject_id: question?.subject_id,
      });
      setIndicators(toSelect(resData.map(x => ({ ...x, name: x.description }))));
    } catch (error) {
      throw error;
    }
  }

  const onChange = (value, target) => {
    if (target === "percentage") {
      const formattedValue = formatNumber(value);
      if (formattedValue === null) return;
      const toNumber = formatToApi(formattedValue)
      if (toNumber > 100) return;
      value = formattedValue;
    }
    setForm(s => ({ ...s, [target]: value }));
  }

  const isValidForm = () => {
    const { school_lapse } = question
    if (!form.date) {
      toast.error('Debe colocar una fecha')
      return false
    }

    if (moment(form.date).isBefore(moment(school_lapse?.init_date).format('YYYY-MM-DD'))) {
      toast.error('La fecha debe ser mayor o igual a la de inicio del lapso')
      return false
    }

    if (moment(form.date).isAfter(moment(school_lapse?.end_date).format('YYYY-MM-DD'))) {
      toast.error('La fecha debe ser menor o igual a la de finalización del lapso')
      return false
    }

    if (!form.name) {
      toast.error('Debe colocar un nombre')
      return false
    }

    if (!form.indicator_id) {
      toast.error('Debe indicar el tipo de evaluación')
      return false
    }

    if (!form.percentage) {
      toast.error('Debe colocar un porcentaje de evaluación')
      return false
    }

    return true
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    try {
      await TeacherTestsService.tests.editTest({
        ...form,
        percentage: formatToApi(form.percentage),
        professor_id: user.id,
      });
      toast.success('Pregunta editada correctamente');
      return true
    } catch (error) {
      toast.error(String(error) || "Ocurrió un error inesperado");
      return false
    }
  }

  useEffect(() => {
    getSelects();
  }, []);

  return {
    form,
    indicators,
    onChange,
    onSubmit,
  }
}

export default QuestionEdit;